import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import FAQ from './components/FAQ';
import Topics from './components/Topics';
import TopicIndex from './components/TopicIndex';
import About from './components/About';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Media from './components/Media';
import AppEntry from './components/AppEntry';
import Ranking from './components/Ranking';
import Updates from './components/Updates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 [&_section[id]]:scroll-mt-16">
      <Header />
      <main>
        <Hero />
        <Comments />
        <FAQ />
        <Topics />
        <TopicIndex />
        <About />
        <Carousel />
        <Features />
        <Cards />
        <Contact />
        <Media />
        <AppEntry />
        <Ranking />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}